<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div slot="header">
                <div class="row">
                  <div class="col-sm-10">
                    <i style="color: #20a8d8;"></i> Company Names
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <vue-good-table
                mode="remote"
                ref="my-table"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                :columns="columns5"
                :rows="rows5"
                :pagination-options="{
                  enabled: true,
                  perPage: 5,
                }"
                styleClass="vgt-table striped bordered table-sm condensed"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'cust_cmp_name'">
                   
                    <i
                     
                      @click="showCustCard(props.row)"
                      style="color: #63c2de; cursor: pointer;"
                    > {{props.row.cust_cmp_name}}</i>
                    
                    
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
            <!-- <div class="card-body">
              <vue-good-table
                mode="remote"
                ref="my-table"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                :columns="columns4"
                :rows="rows4"
                :pagination-options="{
                  enabled: true,
                  perPage: 5,
                }"
                styleClass="vgt-table striped bordered table-sm condensed"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'action'">
                    
                    <i
                      class="fa fa-eye"
                      @click="viewCard(props.row)"
                      style="color: #63c2de; font-size: 20px; cursor: pointer;"
                    ></i>
                    
                    
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div> -->
          </div>
        </div>
      </div>
      <Spinner v-if="loading"></Spinner>
    </div>
  </template>
  
  <script>
  import Spinner from "../../spinner.vue";
  import { VueEditor } from "vue2-editor";
  import DatePicker from "vue2-datepicker";
  export default {
    name: "Cardlist",
    components: {
      "date-picker": DatePicker,
      Spinner,
    },
    data() {
      return {
        rows: [],
        rows4: [],
        rows5: [],
        todate: "",
        fromdate: "",
        temprow: null,
        warningModal: false,
        warningModal1: false,
        largeModal: false,
        loading: false,
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "purchase_id",
            type: "asc",
          },
          page: 1,
          perPage: 5,
        },
        serverParams1: {
          columnFilters: {},
          sort: {},
          page: 1,
          perPage: 10,
        },
        serverParams2: {
          columnFilters: {},
          sort: {},
          page: 1,
          perPage: 10,
        },
        columns5: [
          // {
          //   label: "Card Id",
          //   field: "id",
          //   width: "10% !important",
          //   thClass: "text-center",
          // },
          {
            label: "Company Name",
            field: "companyname",
            width: "5% !important",
            thClass: "text-left",
            
          },
          {
            label: "Customer Name",
            field: "cust_cmp_name",
            width: "15% !important",
            thClass: "text-left",
          },
                 
          // {
          //   label: "Action",
          //   field: "action",
          //   width: "10% !important",
          //   thClass: "text-left",
          //   tdClass: "text-left",
          // },
        ],
      };
    },
    created(){
     //  this.getTotals();
       this.getCompany();
      //  console.log("Test")
      document.body.classList.hide('sidebar-mobile-show')
    },
    computed: {
      
    
    },
  
    methods: {
       getCompany(){
        console.log("Company")
        var _this=this
        var customer_id = JSON.parse(localStorage.getItem('authUserid'));
        console.log(customer_id)
        var data ={
          phoneno:customer_id
        }
        this.$http.post('api/customers/customerCompanyAccount',data).then(function (response) {
          if (response.data == null) {
             
            } else {
             console.log(response)
             _this.rows5=  response.data;
            }
            document.body.classList.toggle('sidebar-mobile-show')
          }).catch(function (error) {
         console.log("test")
        });
       },
      searchcard() {
        this.updateParams({
          sort: {
            type: "",
            field: "",
          },
          page: 1,
        });
        this.$refs["my-table"].reset();
        this.getTotals();
      },
      showCustCard(row){
        console.log(row);
        var _this = this;
        var cardDetail = {
          company_id : row.company_id,
          regcity_code: row.regcity_code,
          customer_id: row.customer_id
        }
        localStorage.setItem("cardDetail", JSON.stringify(cardDetail));
        _this.$router.push("/customercarddetails");
      },
       viewCard(row) {
        console.log('clicking and row')
        console.log(row)
        this.rows.length = 0;
        let filteParam = {};
        filteParam.page = this.serverParams1.page;
        filteParam.perPage = this.serverParams1.perPage;
        filteParam.sort = this.serverParams1.sort;
        var _this = this;
        this.temprow = row;
        // var comp = 'MUMSAI1';
        // var reg = 'MUM'
        var data = "&filter[where][card_id]=" + row.id;
        // if (this.selectcompany !== null) {
        //   data =
        //     data +
        //     "&filter[where][company_id]="+comp+" &filter[where][regcity]="+reg+"";
        // }
        this.$http
          .get(
            "/api/customercards/srarchpercustomercard?params=" +
              JSON.stringify(filteParam) +
              data
          )
          .then(function (response) {
  
            if (response.data == null) {
              setTimeout(function () {
                _this.loading = false;
              }, 2000);
              alert(
                "Card id - " +
                  row.id +
                  " No Detail Found"
              );
            } else {
              setTimeout(function () {
                _this.loading = false;
              }, 2000);
              _this.$router.props = [row.id];
              localStorage.setItem("card_id", JSON.stringify(row.id));
              _this.$router.push("/customercardmonthlydetials");
            }
          });
      },
      newDate(date1) {
        var dt1 = new Date(date1);
        var year = dt1.getFullYear();
        var month = dt1.getMonth() + 1;
        var day = dt1.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        if (month < 10) {
          month = "0" + month;
        }
        var dt2 = day + "-" + month + "-" + year;
        // var dt2 = year+'-'+month+'-'+day
        return dt2;
      },
  
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
        // this.loadItems();
         this.getTotals();
      },
  
      onPerPageChange(params) {
        this.updateParams({ perPage: params.currentPerPage, page: 1 });
        // this.loadItems();
         this.getTotals();
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },
          page: 1,
        });
        // this.loadItems();
         this.getTotals();
      },
  
      onColumnFilter(params) {
        this.updateParams(params);
        // this.loadItems();
         this.getTotals();
      },
      getTotals(val){    
        console.log('automatic run')
              if(val === 'comp'){
                  if(this.tfrst_time === false){
                    this.tfrst_time = true
                  }
                  else{
                    return
                  }
                }
              var _this=this
              // localStorage.removeItem("customer_id");
               var customer_id =  localStorage.getItem('authUserid')
              var custname = this.selectedcustomer
              let filteParam = {};
              filteParam.page = this.serverParams.page;
              filteParam.perPage = this.serverParams.perPage;
              filteParam.sort = this.serverParams.sort;
              var data=[];
              this.rows=[];
              this.loading = true
              var data = data+"&filter[where][cusid]=" + customer_id;
                
              console.log('hitting pages')
              this.$http.get('/api/customercards/showcustomer_card?params='+JSON.stringify(filteParam)+data)
                      .then(function(response){
                         console.log('customer card response')
                         console.log(response)
                         console.log('total records')
                          console.log(response.data[0])
                        _this.totalRecords = response.data[0].totalRecords;
                        response.data.shift()
                        if(response.data != undefined)
                        _this.rows4=  response.data;
                        // _this.super_user = _this.$store.getters.get_super_user;
                        console.log(_this.super_user)
                        _this.loading = false
                        // console.log(response.data)
                        document.body.classList.toggle('sidebar-mobile-show')
                        
                        }).catch(function(error){
                    console.log(error)
                })
                _this.loading  = false
              },
   
      
  
   
  
  
  
  
     
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/goldcustomers/customerCompanyLists.vue